import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

import { CommonService } from '../../common/services/common.service';

@Injectable()
export class BookingService {

  constructor(private _http: HttpClient, private _commonService: CommonService) { }

  sendTicket(params) {
    return(this._http.post(this._commonService.baseUrl + 'sendticket', params));
  }

  getBookingDetail(params){
    return(this._http.post(this._commonService.baseUrl+'book/recap',params))
  }

}
